var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "regular px-2",
      class: _vm.dynamicClasses,
      style: _vm.dynamicStyles
    },
    [_vm._t("default", [_vm._v(_vm._s(_vm.label))])],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }